import {
    ADD_BODY_CLASSNAME,
    ADD_CLASSNAME,
    OVERRIDE_LAYOUT_CONFIG,
    OVERRIDE_PAGE_LAYOUT_CONFIG,
    REMOVE_BODY_CLASSNAME,
    RESET_LAYOUT_CONFIG,
    SET_CLASSNAME_BY_POSITION,
    SET_LAYOUT_CONFIG
} from "@/core/store/modules/layout/constants";
import {STATIC_CONFIG_INITIALIZED} from "@/core/store/modules/config/constants";

export default {
    [SET_LAYOUT_CONFIG](state, payload) {
        state.commit(SET_LAYOUT_CONFIG, payload);
    },
    [RESET_LAYOUT_CONFIG](state) {
        state.commit(RESET_LAYOUT_CONFIG);
    },
    [OVERRIDE_LAYOUT_CONFIG](state) {
        state.commit(OVERRIDE_LAYOUT_CONFIG);
    },
    [OVERRIDE_PAGE_LAYOUT_CONFIG](state, payload) {
        state.commit(OVERRIDE_PAGE_LAYOUT_CONFIG, payload);
    },
    [ADD_BODY_CLASSNAME](context, className) {
        document.body.classList.add(className);
    },
    [REMOVE_BODY_CLASSNAME](context, className) {
        document.body.classList.remove(className);
    },
    [ADD_CLASSNAME](context, payload) {
        context.commit(SET_CLASSNAME_BY_POSITION, payload);
    },
    [STATIC_CONFIG_INITIALIZED](context) {
        let storageKey = 'APP_VERSION'
        const version = context.rootState.config.version ?? 'v1.0.0'
        const storageVersion = localStorage.getItem(storageKey);
        if (storageVersion === null) {
            localStorage.setItem(storageKey, version)
        } else if (storageVersion != version) {
            localStorage.setItem(storageKey, version)
            window.location.reload(true)
        }
    }
}